
const asyncStorageKeys = {
    TOKEN: 'TOKEN',
    USER_TYPE:'USER_TYPE',
    USER_ID:'USER_ID'
};

export default asyncStorageKeys;
